import React from 'react'
import PropTypes from 'prop-types'
import { Row, Col, Form} from 'react-bootstrap'
import FieldGroup from '../../../../common/forms/FieldGroup'
import SubmitButton from '../../../../common/forms/SubmitButton'
import * as styles from './_ConfigureRateLimiter.scss'
import withStyles from 'isomorphic-style-loader/withStyles'
import SuccessCheckMessage from '../../../../common/SuccessCheckMessage'

function isRateLimitSet(status) {
  return status === 'RATE_LIMIT_SET'
}

const ConfigureRateLimiter = ({
  loading,
   emailRateLimiter,
   setEmailRateLimiter,
   updateRateLimiter,
   administratorId,
   submittedStatus
}) => {
  return <Row>
    <Col className={styles['rate-limiter']}>
      <h1 className={styles['heading']}>Configure Email Rate Limit</h1>
      <form>
        <Form.Group
          controlId='configure-rate-limiter'
        >
          <FieldGroup
            id='email-rate-limiter'
            label='Daily Email Rate Limit'
            required
            type='number'
            min={1}
            value={isNaN(parseInt(emailRateLimiter, 10)) ? '' : parseInt(emailRateLimiter, 10)}
            validationstate='success'
            message={'This is the maximum number of emails that can be sent in a day. If a users limit is reached, the system will stop sending emails until the next day for that specific user.'}
            handleChange={(value) => {
              setEmailRateLimiter(Math.max(1, parseInt(value, 10)))
            }}
          />
          <SubmitButton
            onClick={() => { updateRateLimiter(emailRateLimiter, administratorId) }}
            isValid={!loading && !isNaN(emailRateLimiter)}
            preventDefault
            isSubmitting={loading}
            buttonText='Update Limit'
          />
          {isRateLimitSet(submittedStatus) && <p><SuccessCheckMessage message="Email Rate Limit Set." /></p>}
        </Form.Group>
      </form>
    </Col>
  </Row>
}

ConfigureRateLimiter.propTypes = {
  emailRateLimiter: PropTypes.number.isRequired,
  administratorId: PropTypes.number,
  loading: PropTypes.bool.isRequired,
  setEmailRateLimiter: PropTypes.func.isRequired,
  updateRateLimiter: PropTypes.func.isRequired,
  submittedStatus: PropTypes.string
}

export default  (ConfigureRateLimiter)
